// Copyright 2018 The MathWorks, Inc.

/**
 * This maps status bar related widget types to their corresponding class.
 */

define([
    "./TypeConstants",
    "./widgets/StatusBar",
    "./widgets/StatusGroup",
    "./widgets/StatusLabel",
    "./widgets/StatusProgressBar",
    "./widgets/StatusPushButton",
    "./widgets/StatusTextField",
    "./widgets/StatusToggleButton"
], function (TypeConstants, StatusBar, StatusGroup, StatusLabel, StatusProgressBar, StatusPushButton, StatusTextField, StatusToggleButton) {
    var hash = {};

    hash[TypeConstants.STATUS_BAR] = StatusBar;
    hash[TypeConstants.STATUS_GROUP] = StatusGroup;
    hash[TypeConstants.STATUS_LABEL] = StatusLabel;
    hash[TypeConstants.STATUS_PROGRESS_BAR] = StatusProgressBar;
    hash[TypeConstants.STATUS_PUSH_BUTTON] = StatusPushButton;
    hash[TypeConstants.STATUS_TEXT_FIELD] = StatusTextField;
    hash[TypeConstants.STATUS_TOGGLE_BUTTON] = StatusToggleButton;

    return hash;
});
